import { createFileRoute, redirect } from "@tanstack/react-router";
import { routePaths } from "../constants";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Route: any = createFileRoute("/")({
  beforeLoad: () => {
    return redirect({
      to: routePaths.login,
    });
  },
});
